module.exports = __webpack_public_path__ + "static/media/56477c14-4e8a-452e-bd98-b27a182893df.dabf8a12.JPG";